<template>
    <div class="sign-up d-flex justify-center align-center" v-resize="resizeHandler">
        <div class="form-l">
            <div class="form-l__inner">
                <div class="form-l__title">
                    <h4 class="title-h4">
                        Multitraining registration
                    </h4>
                </div>
                <div class="form-l__body">
                    <form @submit.prevent="registrationHandler">
                        <div class="d-flex justify-space-between sign-up__item">
                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.first_name") }}
                                </div>
                                <div class="form__row-field">
                                    <textField
                                            v-model.trim="clientSignUp.firstName"
                                            :v="$v.clientSignUp.firstName"
                                            :placeholder="$t('form.first_name_placeholder')"
                                            type="text"
                                            :theme="actualWidth >= 600 ? 'light' : 'dark'"
                                    />
                                </div>
                            </div>

                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.last_name") }}
                                </div>
                                <div class="form__row-field">
                                    <textField
                                            v-model.trim="clientSignUp.lastName"
                                            :v="$v.clientSignUp.lastName"
                                            :placeholder="$t('form.last_name_placeholder')"
                                            type="text"
                                            :theme="actualWidth >= 600 ? 'light' : 'dark'"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-space-between sign-up__item">
                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.email") }}
                                </div>
                                <div class="form__row-field">
                                    <textField
                                            v-model.trim="clientSignUp.email"
                                            :v="$v.clientSignUp.email"
                                            :placeholder="$t('form.email_address')"
                                            type="text"
                                            :theme="actualWidth >= 600 ? 'light' : 'dark'"
                                    />
                                </div>
                            </div>

                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.studio") }}
                                </div>
                                <div class="form__row-field pb-5">
                                    <DropdownAutocomplete
                                            :v="$v.clientSignUp.studio_id"
                                            :list="studiosListDropdown"
                                            :placeholder="$t('form.studio_placeholder')"
                                            @update="updateStudioHandler"
                                            :theme="actualWidth >= 600 ? 'light' : 'dark'"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-space-between sign-up__item">
                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.password") }}
                                </div>
                                <div class="form__row-field is-password">
                                    <textField
                                            v-model.trim="clientSignUp.password"
                                            :v="$v.clientSignUp.password"
                                            :placeholder="$t('form.password_placeholder')"
                                            type="password"
                                            :theme="actualWidth >= 600 ? 'light' : 'dark'"
                                    />
                                </div>
                            </div>

                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.password_confirmation") }}
                                </div>
                                <div class="form__row-field">
                                    <textField
                                            v-model.trim="clientSignUp.passwordConfirm"
                                            :v="$v.clientSignUp.passwordConfirm"
                                            :placeholder="$t('form.password_confirmation_placeholder')"
                                            type="password"
                                            :theme="actualWidth >= 600 ? 'light' : 'dark'"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-space-between sign-up__item mt-8">
                            <div class="form__row">
                                <div class="form__row-field sign-up__privacy">
                                    <checkbox
                                            @input="gdbrHandler"
                                            :v="$v.clientSignUp.gdpr_agreement"
                                    >
                                        <div class="sign-up__label">
                                            <span >{{$t('members.sign_up.policy_1')}}</span>
                                            <router-link to="/members/privacy" class="members-link">{{$t('members.sign_up.policy_link')}}</router-link>
                                            <span>{{$t('members.sign_up.policy_2')}}</span>
                                        </div>

                                    </checkbox>
                                </div>
                            </div>

                            <div class="d-flex justify-space-between sign-up__item">
                                <div class="form__row">
                                    <div class="form__row-field sign-up__privacy">
                                        <checkbox
                                                @input="termsHandler"
                                                :v="$v.clientSignUp.terms_agreement"
                                        >
                                            <div class="sign-up__label">
                                                <span>{{$t('members.sign_up.terms_1')}}</span>
                                                <router-link to="/members/terms-of-use" class="members-link">{{$t('members.sign_up.terms_link')}}</router-link>
                                                <span>{{$t('members.sign_up.terms_2')}}</span>
                                            </div>
                                        </checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-center sign-up__button">
                            <button class="btn btn-m btn-gradient" :disabled="isRegButton">
                                <span>{{$t('form.register')}}</span>
                            </button>
                        </div>

                        <div class="sign-up__login text-center">
                            <span>Eingetragen? </span>
                            <router-link to="/members/sign-in" class="members-link">Einloggen</router-link>
                        </div>

                    </form>
                </div>
            </div>
        </div >
    </div>
</template>

<script>
    import { getStudiosList } from "@/api/clientServices";
    import validate from '@/mixins/validate';
    import textField from "@/elements/textField";
    import resize from "@/mixins/resize";
    import DropdownAutocomplete from "@/elements/DropdownAutocomplete";
    import checkbox from '@/elements/checkbox';
    import {registration} from "../../../api/clientServices";

    export default {
        mixins: [validate, resize],

        components: {
            textField,
            checkbox,
            DropdownAutocomplete,
        },

        data() {
            return {
                clientSignUp: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    studio_id: '',
                    password: '',
                    passwordConfirm: '',
                    gdpr_agreement: '',
                    terms_agreement: ''
                },
                studiosList: [],
                studiosListDropdown: [],
                isRegButton: false
            }
        },

        async created() {
            this.isRegButton = false;
            try {
                const res = await getStudiosList();

                this.studiosList = res.data.data.studios;
                this.studiosList.forEach(studio => {
                    this.studiosListDropdown.push(studio.title);
                });
            } catch (e) {
                console.log(e, 'getStudioList Error');
            }
        },

        methods: {
            async registrationHandler() {
                this.$v.clientSignUp.$touch();
                if(this.$v.clientSignUp.$invalid) return;
                const {
                    email,
                    password,
                    passwordConfirm: password_confirmation,
                    lastName: last_name,
                    firstName: first_name,
                    studio_id,
                    gdpr_agreement,
                    terms_agreement
                } = this.clientSignUp;

                const data = {
                    email,
                    password,
                    last_name,
                    first_name,
                    password_confirmation,
                    studio_id,
                    gdpr_agreement,
                    terms_agreement
                };
                this.isRegButton = true;
                try {
                    await registration(data);
                    this.$router.push('/members/sign-up-sent');
                    this.isRegButton = false;
                } catch (e) {
                    this.isRegButton = false;
                    let errors = e.response.data.errors
                    Object.keys(errors).forEach(key => {
                        this.$store.dispatch('ADD_ALERT', {type: "error", text: errors[key][0]})
                    })
                }
            },

            updateStudioHandler(selected) {
                this.clientSignUp.studio_id = this.studiosList.find(studio => studio.title === selected).id;
            },

            gdbrHandler(value) {
                let gdbr = value ? +value : '';
                this.clientSignUp.gdpr_agreement = gdbr;
            },

            termsHandler (value) {
                const terms = value ? +value : '';
                this.clientSignUp.terms_agreement = terms;
            }
        }
    }
</script>

<style lang="sass" scoped>
.sign-up
    flex: 1 1 auto
    height: calc(100% - 40px)

    +r(1023)
        margin-top: 30px

    &__privacy
        /*padding-top: 30px*/
        width: 346px
        +reg
        font-size: 12px
        color: $color--dark
        +r(1023)
            width: 329px

        +r(860)
            width: 309px

        +r(767)
            padding-top: 0

        +r(599)
            width: 100%
            color: $color--white

        &::v-deep
            .checkbox-l
                margin-left: 0
                padding-left: 0
                margin-right: 8px
                padding-right: 0

    &__item
        +r(767)
            flex-direction: column
            align-items: center

    &__button
        margin: 40px 0 32px

    &__login
        text-align: center
        +reg
        font-size: 14px
        color: $color--dark

        +r(599)
            text-align: left
            color: $color--white

    &__label
        margin-left: 8px
    .form-l
        max-width: 887px

        +r(1023)
            &__inner
                padding: 60px 25px

        +r(860)
            &__inner
                padding: 60px 10px

        +r(599)
            &__inner
                padding-top: 0
                padding-bottom: 32px

    .form__row
        width: 346px
        +r(1023)
            width: 329px

        +r(860)
            width: 309px

        +r(599)
            width: 100%

        &::v-deep
            .dropdown

                .field
                    height: 48px

                +r(767)
                    margin-bottom: 24px


.form
    &__row
        position: relative
</style>